/* eslint-disable prefer-destructuring */
import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { AppContext } from '../../Context/app-state';

function valuetext(value: number) {
  return `${value}`;
}

const PrettoSlider = styled(Slider)({
  color: '#278D9F',
  height: 8,
  width: 400,
  margin: '0px 20px 0px 20px',
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#278D9F',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

const minDistance = 1;

export default function MinimumDistanceSlider() {
  const { filters, setFilters } = React.useContext(AppContext);
  const { maxCopiesCount, minCopiesCount } = filters;

  const handleChange1 = (
    event: Event,
    newValue: number | number[],
    activeThumb: number,
  ) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    let max;
    let min;
    if (activeThumb === 0) {
      min = Math.min(newValue[0], maxCopiesCount - minDistance);
      max = maxCopiesCount;
    } else {
      min = minCopiesCount;
      max = Math.max(newValue[1], minCopiesCount + minDistance);
    }
    setFilters({ ...filters, maxCopiesCount: max, minCopiesCount: min });
  };

  const { maxCopiesYear, minCopiesYear } = filters;

  const handleChange2 = (
    event: Event,
    newValue: number | number[],
    activeThumb: number,
  ) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    let max;
    let min;
    if (activeThumb === 0) {
      min = Math.min(newValue[0], maxCopiesYear - minDistance);
      max = maxCopiesYear;
    } else {
      min = minCopiesYear;
      max = Math.max(newValue[1], minCopiesYear + minDistance);
    }
    setFilters({ ...filters, maxCopiesYear: max, minCopiesYear: min });
  };

  return (
    <Box>
      <span className="range-count__span">Количество экземпляров:</span>
      <div className="range-count__slider-container">
        <output className="slider-output">{minCopiesCount}</output>
        <PrettoSlider
          getAriaLabel={() => 'Minimum distance'}
          value={[minCopiesCount, maxCopiesCount]}
          onChange={handleChange1}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          disableSwap
          min={1}
          step={1}
          max={12}
        />
        <output className="slider-output">{maxCopiesCount}</output>
      </div>
      <span className="range-year__span">Год приобретения:</span>
      <div className="range-year__slider-container">
        <output className="slider-output">{minCopiesYear}</output>
        <PrettoSlider
          getAriaLabel={() => 'Minimum distance shift'}
          value={[minCopiesYear, maxCopiesYear]}
          onChange={handleChange2}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          disableSwap
          min={1940}
          step={10}
          max={2020}
        />
        <output className="slider-output">{maxCopiesYear}</output>
      </div>
    </Box>
  );
}
